import { NavLink, Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { NAV } from "@/constants/testIds";

export default function MobileMenu({ links }) {
  return (
    <div
      data-testid={NAV.mobileMenu}
      className="lg:hidden bg-ivory border-t border-line-light"
    >
      <div className="px-6 py-10 flex flex-col gap-6">
        {links.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            end={l.end}
            data-testid={`${l.id}-mobile`}
            className="text-ink text-sm tracking-widest2 uppercase"
          >
            {l.label}
          </NavLink>
        ))}
        <a
          href="https://wa.me/918287828387"
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 text-[11px] tracking-widest2 uppercase text-ink mt-2"
        >
          <Phone size={14} /> +91 82878 28387
        </a>
        <Link
          to="/contact"
          className="mt-4 inline-block border border-ink px-6 py-3 text-[10px] tracking-widest2 uppercase text-center"
          data-testid={`${NAV.cta}-mobile`}
        >
          Plan a Journey
        </Link>
      </div>
    </div>
  );
}
